export let credentials = {};

export const setCredentials = (creds) => credentials = creds;